<div class="page">
    <!-- Main Navbar-->

    <sume-home-header></sume-home-header>

    <div class="page-content d-flex align-items-stretch">
        <!-- Side Navbar -->

        <app-home-sidebar class="sidebar"></app-home-sidebar>
        <div class="content-inner">
            <alert></alert>
            <sume-container-page>
                <router-outlet></router-outlet>
            </sume-container-page>
            <!-- Page Footer-->
            <sume-home-footer></sume-home-footer>
        </div>
    </div>
</div>
